<template>
  <div class="basic-layout">
    <div class="basic-layout__toolbar">
      <theme-toggle-component />
    </div>
    <child></child>
  </div>
</template>

<script>
import Child from "../Child";
import ThemeToggleComponent from "@/pages/components/ThemeToggleComponent.vue";

export default {
  name: "BasicLayout.vue",
  components: {
    Child,
    ThemeToggleComponent,
  },
};
</script>

<style scoped>
.basic-layout {
  position: relative;
  min-height: 100vh;
  background: var(--portal-bg);
  color: var(--portal-text);
}

.basic-layout__toolbar {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 10;
}
</style>
